import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.SENTRY_DSN || "https://b021760973d843be86f38581dcf2c560@o405200.ingest.sentry.io/6385691",
  environment: process.env.APP_ENV,
  tracesSampleRate: 1.0,
});
